"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import {
  registerGlobalHandlers,
  setReporterUserId,
} from "@/lib/clientErrorReporter";

/**
 * Glues together two things our error reporter needs but can't do from
 * module scope: read the active userId via NextAuth, and register browser
 * window handlers inside an effect (so they're skipped during SSR).
 *
 * Render-tree placement: must live inside SessionProvider. Keeps no UI of
 * its own.
 */
export function ClientErrorReporterProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: session } = useSession();

  // Tag every subsequent report with the active user, then clear on logout.
  useEffect(() => {
    setReporterUserId(session?.user?.id);
  }, [session?.user?.id]);

  // Window-level handlers register once per mount. Effect cleanup removes
  // them on unmount — a no-op in practice since this provider lives at the
  // root, but it's the correct pattern.
  useEffect(() => {
    return registerGlobalHandlers();
  }, []);

  return <>{children}</>;
}
